"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExtraWalletSupported = exports.supportedExtraWallets = exports.UserExternalWalletsProvider = exports.useUserExternalWallets = void 0;
var useUserExternalWallets_1 = require("./useUserExternalWallets");
Object.defineProperty(exports, "useUserExternalWallets", { enumerable: true, get: function () { return useUserExternalWallets_1.useUserExternalWallets; } });
Object.defineProperty(exports, "UserExternalWalletsProvider", { enumerable: true, get: function () { return useUserExternalWallets_1.UserExternalWalletsProvider; } });
exports.supportedExtraWallets = ['SOL', 'TERRA', 'SUI'];
var isExtraWalletSupported = function (network) {
    return exports.supportedExtraWallets.includes(network);
};
exports.isExtraWalletSupported = isExtraWalletSupported;
